"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportPermissionAdminAdd = reportPermissionAdminAdd;
exports.reportPermissionMenuAdd = reportPermissionMenuAdd;
exports.reportPermissionRoleSet = reportPermissionRoleSet;
var _adminOperationReport = require("@/utils/adminOperationReport");
var _reportContent = require("@/utils/reportContent");
/**
 * 【操作埋点】权限管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：菜单新增、管理员添加、PC/小程序权限分配
 */

var MENU_LABELS = {
  title: '页面标题',
  name: '页面名称',
  path: 'url地址',
  file_path: '组件地址',
  menu_type: '菜单所属',
  status: '状态',
  hidden: '显示'
};

/**
 * 新增菜单埋点上报
 */
function reportPermissionMenuAdd(menuInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '新增菜单',
    content: (0, _reportContent.buildReportContent)(menuInfo, MENU_LABELS, {
      prefix: '新增后台菜单'
    }),
    operation_id: 'pc_permission_menu_add_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_permission_menu_add_1');
}

/**
 * 添加管理员埋点上报
 */
function reportPermissionAdminAdd(adminInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '添加管理员',
    content: "\u65B0\u589E\u7BA1\u7406\u5458\u300C".concat(adminInfo.nick_name || '', "\u300D\uFF0C\u767B\u5F55\u540D ").concat(adminInfo.user_name || '', "\uFF0C\u624B\u673A\u53F7 ").concat(adminInfo.phone || '', "\uFF0C\u6743\u9650\u7C7B\u578B ").concat(adminInfo.roles || ''),
    operation_id: 'pc_permission_admin_add_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_permission_admin_add_1');
}

/**
 * 分配权限埋点上报
 */
function reportPermissionRoleSet(adminId, adminName, roleIds) {
  var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'PC端';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: "".concat(platform, "\u6743\u9650\u5206\u914D"),
    content: "\u4E3A\u7BA1\u7406\u5458\u300C".concat(adminName || '', "\u300D(ID:").concat(adminId, ") \u5206\u914D").concat(platform, "\u6743\u9650\uFF0C\u83DC\u5355ID\uFF1A").concat(roleIds || '无'),
    operation_id: 'pc_permission_role_set_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_permission_role_set_1');
}